import { FC } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './PrototypeBar.module.scss';

export const PrototypeBar: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const currentPath = location.pathname;

  const screens = [
    { id: 'asset', label: '01 Asset detail', path: '/asset-data/ahu-003' },
    { id: 'mobile', label: '02 Mobile asset', path: '/mobile-asset' },
    { id: 'qrmanage', label: '03 QR management', path: '/asset-data/ahu-003/qr' },
    { id: 'room', label: '04 Plant Room 01', path: '/locations/plant-room-01' },
    { id: 'ai', label: '05 Contextual AI', path: '/contextual-ai' },
  ];

  return (
    <div className={styles.prototypeBar} aria-label="Prototype screens navigation">
      <div className={styles.barHeader}>
        <span className={styles.badge}>Interactive Demo</span>
        <span>Click to test prototype screens:</span>
      </div>
      <div className={styles.screensList}>
        {screens.map((screen) => {
          const isActive = currentPath === screen.path;
          return (
            <button
              key={screen.id}
              type="button"
              className={`${styles.screenBtn} ${isActive ? styles.active : ''}`}
              onClick={() => navigate(screen.path)}
            >
              {screen.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
